import { Container } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import React, { FunctionComponent } from "react";

export interface InstallSectionProps {
  title: string;
  description: string;
  children: React.ReactNode;
}

/**
 * Reusable section wrapper for install buttons
 */
export const InstallSection: FunctionComponent<InstallSectionProps> = ({ title, description, children }) => (
  <Container paddingTop={10}>
    <Text fontSize="T200" fontWeight={600}>
      {title}
    </Text>
    <Container paddingTop={5}>
      <Text fontSize="T100">{description}</Text>
    </Container>
    <Container paddingTop={10}>{children}</Container>
  </Container>
);
